import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewSliderComponent } from "./med-icon-view-slider.component";

@NgModule({
  declarations: [
    MedIconViewSliderComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewSliderComponent,
  ],
})
export class MedIconViewSliderModule { }
